"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkTypeFromContent = void 0;
const fs_1 = __importDefault(require("fs"));
const eachLine_1 = __importDefault(require("../utils/eachLine"));
const checkTypeByHeadLines_1 = __importDefault(require("./checkTypeByHeadLines"));
const getParserOpt_1 = __importDefault(require("./getParserOpt"));
const error_1 = require("../utils/error");
const characteristics_1 = require("../@types/characteristics");
const LINE_COUNT = 5;
function checkType(fileName) {
    const headLines = [];
    if (!fs_1.default.existsSync(fileName))
        throw new Error(`${fileName} does not exist, please check!`);
    return (0, eachLine_1.default)(fileName, (line, lineIndex) => {
        headLines.push(line);
        if (lineIndex >= LINE_COUNT)
            return false;
    }, (line) => {
        return line.startsWith('#') || line === '';
    }).then(() => {
        const alignType = (0, checkTypeByHeadLines_1.default)(headLines);
        alignType === characteristics_1.AlignType.UNKNOWN && (0, error_1.warn)('Unknown input alignment type!');
        return {
            alignType,
            parserOpt: (0, getParserOpt_1.default)(alignType, headLines),
        };
    });
}
exports.default = checkType;
function checkTypeFromContent(content) {
    const headLines = content.trim().split('\n').filter(line => {
        return !(line.startsWith('#') || line === '');
    }).slice(0, 5);
    const alignType = (0, checkTypeByHeadLines_1.default)(headLines);
    if (alignType === characteristics_1.AlignType.UNKNOWN) {
        throw new Error('Unknown input alignment type!');
    }
    return {
        alignType,
        parserOpt: (0, getParserOpt_1.default)(alignType, headLines),
    };
}
exports.checkTypeFromContent = checkTypeFromContent;
